var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"category-main"},[_c('div',{staticClass:"category-item"},[_c('div',{staticClass:"category-key"},[_vm._v("分类类目管理:")]),_c('div',{staticClass:"category-val"},[_c('b-goods-category',{attrs:{"isEdit":"","isInit":""}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }